import { useEffect, useState } from 'react';
import { api } from './api';

let cache = null;

// Public company identity (legal name, GSTIN, PAN) shared across footer / contact pages.
export function useCompany() {
  const [c, setC] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get('/company-profile/public').then((r) => { cache = r.data; setC(r.data); }).catch(() => {});
  }, []);
  return c;
}
